import { IStation, IMapBounds } from "@/interfaces/Map";
import { AIRPORT_ICONS, desc_min_zoom, initialZoom } from "@/constants/Map";
import { CONFIG, GENERAL } from "@/constants";
import { Nullable } from "@/types";

export const getMarkerIcon = (
  type: string,
  stationId: Nullable<number>,
  selectedMarkerId: Nullable<number>,
  selectedStationDataId: Nullable<number>
): string => {
  if (
    stationId &&
    (selectedMarkerId === stationId || selectedStationDataId === stationId)
  ) {
    return "/mapIcons/Selected.svg";
  }
  return (
    AIRPORT_ICONS[type as keyof typeof AIRPORT_ICONS] || AIRPORT_ICONS.default
  );
};

export const stationsToGeoJSON = (stationsData: IStation[]) => {
  return stationsData.map((station) => ({
    type: "Feature" as const,
    properties: {
      stationId: station.id,
      type: station.type,
      cluster: false,
    },
    geometry: {
      type: "Point" as const,
      coordinates: [station.longitude, station.latitude],
    },
  }));
};

export const isBoundsOutsideCached = (
  currentBounds: IMapBounds,
  cachedBounds: IMapBounds
): boolean => {
  if (!cachedBounds) return true;
  return (
    currentBounds.southwest.lat < cachedBounds.southwest.lat ||
    currentBounds.southwest.lng < cachedBounds.southwest.lng ||
    currentBounds.northeast.lat > cachedBounds.northeast.lat ||
    currentBounds.northeast.lng > cachedBounds.northeast.lng
  );
};

export const addPaddingToBounds = (
  bounds: IMapBounds,
  paddingPercent: number = GENERAL.BOUNDS_PADDING_PERCENT
): IMapBounds => {
  const latDiff = bounds.northeast.lat - bounds.southwest.lat;
  const lngDiff = bounds.northeast.lng - bounds.southwest.lng;

  const latPadding = latDiff * paddingPercent;
  const lngPadding = lngDiff * paddingPercent;

  return {
    southwest: {
      lat: bounds.southwest.lat - latPadding,
      lng: bounds.southwest.lng - lngPadding,
    },
    northeast: {
      lat: bounds.northeast.lat + latPadding,
      lng: bounds.northeast.lng + lngPadding,
    },
  };
};

export const getClusterGridSize = (zoom: number) => {
  const gridSize =
    zoom >= initialZoom
      ? CONFIG.MARKER_CLUSTERER.GRID_SIZE_NEAR
      : CONFIG.MARKER_CLUSTERER.GRID_SIZE_FAR;
  return gridSize;
};
